var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/utils/class-utils';
import React, { forwardRef } from 'react';
export var Text = forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b, disabled = _a.disabled, _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, htmlFor = _a.htmlFor, props = __rest(_a, ["variant", "disabled", "className", "children", "htmlFor"]);
    var variantStyles = {
        default: 'text-gray-900',
        error: 'text-vjwDanger text-sm',
        description: 'text-typographySubHeadingTextColor text-typographySubheadingFontSize font-typographySubheadingFontWeight',
        label: 'text-typographyLabelsFontSize text-typographyLabelsTextColor font-typographyLabelsFontWeight',
        heading: 'text-typographyHeadingFontSize font-typographyHeadingFontWeight text-typographyHeadingTextColor',
    };
    var combinedClassName = "".concat(variantStyles[variant], " ").concat(cn({ 'opacity-50': disabled }, className));
    if (variant === 'label') {
        return (_jsx("label", __assign({ ref: ref, className: combinedClassName, htmlFor: htmlFor }, props, { children: children })));
    }
    return (_jsx("p", __assign({ ref: ref, className: combinedClassName }, props, { children: children })));
});
Text.displayName = 'Text';
